export function FloatingDots() {
    return <div id={"loading-indicator"} className="flex flex-row items-center space-x-1 px-2 py-1">
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-dot-pulse"
             style={{animationDelay: "0ms"}}></div>
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-dot-pulse"
             style={{animationDelay: "200ms"}}></div>
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-dot-pulse"
             style={{animationDelay: "400ms"}}></div>
    </div>;
}
